(function(){
  var country = window.MSK_COUNTRY || '';
  var langMap = { 'ES': 'es', 'NL': 'nl' };
  var lang = langMap[country];
  if (!lang) return;

  // ── Auto-langue ──────────────────────────────────────────────────────────
  var LANG_KEY = 'msk_lang';
  if (!localStorage.getItem(LANG_KEY)) {
    function setLang() {
      if (typeof mskSetLang === 'function') { mskSetLang(lang); }
      else { setTimeout(setLang, 50); }
    }
    setLang();
  }

  // ── Données par pays ─────────────────────────────────────────────────────
  var data = {
    nl: {
      landingNames: [
        "Liam V. — Amsterdam","Sophie D. — Rotterdam","Tim B. — Utrecht",
        "Emma K. — Den Haag","Noah J. — Eindhoven","Lisa M. — Groningen",
        "Daan R. — Tilburg","Sara W. — Almere"
      ],
      photoReviews: [
        {t:'"Ontvangen in perfecte staat! Heel goed verpakt met de MySportKits kaart. 100% aanbevolen!"', n:'Liam V. — Amsterdam'},
        {t:'"De TNs zijn top, perfecte maat. Het wachten was het zeker waard."', n:'Sophie D. — Rotterdam'},
        {t:'"Topkwaliteit voor de prijs! Precies zoals op de foto\'s. Zeer tevreden."', n:'Tim B. — Utrecht'},
        {t:'"Prachtig! Perfecte maat, zorgvuldige verpakking met bedankkaart."', n:'Emma K. — Den Haag'},
        {t:'"Maat 42, super comfortabel. Kleur precies zoals verwacht."', n:'Noah J. — Eindhoven'},
        {t:'"Besteld voor mijn dochter (36), ze is er super blij mee!"', n:'Lisa M. — Groningen'},
        {t:'"Zwarte/gele TNs van topkwaliteit. Betrouwbare winkel, al mijn 3e bestelling!"', n:'Daan R. — Tilburg'},
        {t:'"2e aankoop bij MySportKits, altijd top! Prachtige witte schoenen."', n:'Sara W. — Almere'},
        {t:'"Ontvangen in uitstekende staat. Mijn buurman heeft er ook een besteld!"', n:'Finn B. — Breda'}
      ],
      textReviews: [
        {s:'★★★★★', t:'Ongelofelijke kwaliteit voor de prijs. Levering iets lang maar echt de moeite waard. Ik raad het aan!', a:'Liam V.', l:'Amsterdam'},
        {s:'★★★★★', t:'Heel tevreden met mijn bestelling, de schoenen zijn prachtig. Maat klopt. Al een tweede paar besteld.', a:'Sophie D.', l:'Rotterdam'},
        {s:'★★★★★', t:'Prijs/kwaliteit onverslaanbaar. Mijn vrienden denken dat ze echt zijn en kosten 5x minder. Klantenservice ook super.', a:'Tim B.', l:'Utrecht'},
        {s:'★★★★☆', t:'Prachtig paar, klopt met de beschrijving. Een ster minder door de iets langere levertijd, maar de kwaliteit is er.', a:'Emma K.', l:'Den Haag'},
        {s:'★★★★★', t:'Tweede bestelling bij MySportKits. Altijd betrouwbaar. De TNs zijn perfect, zorgvuldige afwerking, stevige zool.', a:'Noah J.', l:'Eindhoven'},
        {s:'★★★★★', t:'Cadeau voor mijn zoon, hij is er dol op! Juiste maat dankzij de maattabel. Zorgvuldige verpakking. Geweldige ervaring.', a:'Lisa M.', l:'Groningen'}
      ],
      photoTag:   '📸 Geverifieerde foto-recensies',
      photoTitle: 'ZIJ ONTVINGEN HUN BESTELLING',
      badge:      '✓ Geverifieerd'
    },
    es: {
      landingNames: [
        "Carlos M. — Madrid","Sofia R. — Barcelona","Diego L. — Valencia",
        "Ana G. — Sevilla","Pablo T. — Zaragoza","Lucia F. — Málaga",
        "Javier S. — Murcia","María C. — Bilbao"
      ],
      photoReviews: [
        {t:'"¡Recibido en perfecto estado! Muy bien embalado con la tarjeta MySportKits. ¡100% recomendado!"', n:'Carlos M. — Madrid'},
        {t:'"Las TN están geniales, talla perfecta. Mereció la pena la espera."', n:'Sofia R. — Barcelona'},
        {t:'"¡Calidad top para el precio! Exactamente como en las fotos."', n:'Diego L. — Valencia'},
        {t:'"¡Preciosas! Talla perfecta, embalaje cuidado con tarjeta de agradecimiento."', n:'Ana G. — Sevilla'},
        {t:'"Talla 42, súper cómodas. El color exactamente como esperaba."', n:'Pablo T. — Zaragoza'},
        {t:'"Pedido para mi hija (36), ¡está encantada! Zapatillas impecables."', n:'Lucia F. — Málaga'},
        {t:'"TNs negras/amarillas de gran calidad. Tienda fiable, ¡ya es mi 3er pedido!"', n:'Javier S. — Murcia'},
        {t:'"2ª compra en MySportKits, ¡siempre a tope! Zapatillas blancas preciosas."', n:'María C. — Bilbao'},
        {t:'"Recibido en excelente estado. ¡Mi vecino también ha pedido después de ver las mías!"', n:'Miguel A. — Alicante'}
      ],
      textReviews: [
        {s:'★★★★★', t:'Calidad increíble, exactamente como en las fotos. Entrega un poco larga pero totalmente vale la pena. ¡Lo recomiendo!', a:'Carlos M.', l:'Madrid'},
        {s:'★★★★★', t:'Muy satisfecho con mi pedido, las zapatillas son preciosas. Talla correcta. Ya pedí un segundo par.', a:'Sofia R.', l:'Barcelona'},
        {s:'★★★★★', t:'Precio/calidad imbatible. Mis amigos creen que son originales y cuestan 5x menos. Atención al cliente reactiva también.', a:'Diego L.', l:'Valencia'},
        {s:'★★★★☆', t:'Par precioso, fiel a la descripción. Le quito una estrella por el plazo algo largo, pero la calidad está ahí.', a:'Ana G.', l:'Sevilla'},
        {s:'★★★★★', t:'Segundo pedido en MySportKits. Siempre serios. Las TN son perfectas, acabados cuidados, suela bien firme.', a:'Pablo T.', l:'Zaragoza'},
        {s:'★★★★★', t:'Regalo para mi hijo, ¡está loco de alegría! Talla exacta gracias a la guía. Embalaje cuidado. Muy buena experiencia.', a:'Lucia F.', l:'Málaga'}
      ],
      photoTag:   '📸 Reseñas verificadas con fotos',
      photoTitle: 'ELLOS RECIBIERON SU PEDIDO',
      badge:      '✓ Verificado'
    }
  };

  var d = data[lang];

  // ── Description produit ──────────────────────────────────────────────────
  var descTexts = {
    nl: 'Premium kwaliteit sneakers. Comfortabele pasvorm, duurzame materialen. Wereldwijde verzending in 7-14 werkdagen.',
    es: 'Zapatillas de calidad premium. Ajuste cómodo, materiales duraderos. Envío mundial en 7-14 días hábiles.'
  };

  function fixDesc() {
    var el = document.querySelector('.product-desc');
    if (!el || el.getAttribute('data-local-desc-done')) return;
    el.setAttribute('data-local-desc-done', '1');
    el.textContent = descTexts[lang];
  }

  // ── Landing reviews row-1 (carousel texte) ───────────────────────────────
  function fixLandingNames() {
    var rvNames = document.querySelectorAll('.reviews-track.row-1 .rv-name');
    if (!rvNames.length) rvNames = document.querySelectorAll('.rv-name');
    rvNames.forEach(function(el, i) {
      el.textContent = d.landingNames[i % d.landingNames.length];
    });
  }

  // ── Photo grid fiche produit (remplace texte/nom/badge, garde les images) ─
  function fixPhotoGrid() {
    var grid = document.getElementById('photo-reviews-grid');
    // Skip if product.liquid DE/UK/AU script already rebuilt the grid
    if (!grid || grid.getAttribute('data-local-done') || grid.getAttribute('data-uk-photo-done')) return;
    grid.setAttribute('data-local-done', '1');
    var cards = grid.querySelectorAll('.rv-photo-card');
    cards.forEach(function(card, i) {
      var pr = d.photoReviews[i % d.photoReviews.length];
      var textEl = card.querySelector('.rv-text');
      var nameEl = card.querySelector('.rv-name');
      var badgeEl = card.querySelector('.rv-badge');
      if (textEl) textEl.textContent = pr.t;
      if (nameEl) nameEl.textContent = pr.n;
      if (badgeEl) badgeEl.textContent = d.badge;
    });
    var pt = document.getElementById('photo-rv-tag');
    if (pt) pt.textContent = d.photoTag;
    var ph = document.getElementById('photo-rv-title');
    if (ph) ph.textContent = d.photoTitle;
  }

  // ── Avis texte fiche produit ("CE QUE DISENT NOS CLIENTS") ──────────────
  function fixTextReviews() {
    var grid = document.querySelector('.reviews-grid');
    if (!grid || grid.getAttribute('data-local-rv-done')) return;
    grid.setAttribute('data-local-rv-done', '1');
    var html = '';
    d.textReviews.forEach(function(r) {
      html += '<div class="review-card">'
            + '<div class="review-stars">' + r.s + '</div>'
            + '<div class="review-text">"' + r.t + '"</div>'
            + '<div class="review-author">' + r.a + ' <span class="review-location">— ' + r.l + '</span></div>'
            + '</div>';
    });
    grid.innerHTML = html;
  }

  function run() {
    fixDesc();
    fixLandingNames();
    fixPhotoGrid();
    fixTextReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 500);
})();
